/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { AccountService } from '../../services/account.service';
import { ConfigService } from '../../services/config.service';
import { MarketoService } from '../../services/marketo.service';
import { EloquaService } from '../../services/eloqua.service';
import { HubspotService } from '../../services/hubspot.service';
import { PardotService } from '../../services/pardot.service';
import { ActonService } from '../../services/acton.service';
import { ErrorService } from '../../services/error.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { DriftService } from '../../services/drift.service';
//import { Animations } from '../../global/animations';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from '../../global/alert-dialog/alert-dialog.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-settings-integration',
  templateUrl: './settings-integration.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class SettingsIntegrationComponent implements OnInit {
  session = null;

  marketoDialogRef: BsModalRef;
  pardotDialogRef: BsModalRef;

  accountData: any;
  loadingPage: boolean = false;
  integrations: boolean = false;

  apiTokens: any[] = [];

  marketoConfig: any = {
    endpoint: '',
    client_id: '',
    client_secret: '',
    testing: false,
    tested: false,
    verified: false,
    resync: false
  };

  hubspotConfig: any = {
    hub_id: '',
    testing: false,
    tested: false,
    verified: false,
    resync: false
  };

  eloquaConfig: any = {
    testing: false,
    tested: false,
    verified: false,
    resync: false
  };

  pardotConfig: any = {
    email_address: '',
    password: '',
    user_key: '',
    business_unitId: '',
    version: 3,
    testing: false,
    tested: false,
    verified: false,
    resync: false,
    client_secret: '',
    client_key: '',
    token:''
  };

  actOnConfig: any = {
    testing: false,
    tested: false,
    verified: false
  };

  driftConfig: any = {
    testing: false,
    tested: false,
    verified: false
  };

  constructor(private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private configService: ConfigService,
    private marketoService: MarketoService,
    private eloquaService: EloquaService,
    private hubspotService: HubspotService,
    private pardotService: PardotService,
    private actonService: ActonService,
    private errorService: ErrorService,
    private cacheService: CacheService,
    private sessionService: SessionService,
    private modalService: BsModalService,
    private driftService: DriftService,
    private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    if (this.route.snapshot.params['id']) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.handleOAuth(() => {
            this.initView();
          });
        }
      )
    }
    else {
      this.session = this.cacheService.get('session');
      if (!this.session) {
        this.sessionService.getSession(true).subscribe(
          (session: any) => {
            this.session = session;
            this.initView();
          }
        )
      }
      else {
        this.initView();
      }
    }
  }

  disconnect(map) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to remove your integration with ${map}`,
        confirm: function () {
          me.accountService.removeIntegration(map.toLowerCase()).subscribe(
            (result: any) => {
              me.globalMessageService.message(`${map} was removed from your account`);
              me.driftService.track('deleted-integration', { type: map });
              me.initView();
            },
            err => {
              me.globalMessageService.error();
              me.errorService.log(err, 'settings-integration.component', 'disconnect');
            });
        }
      }
    }));
  }

  marketoSettings(dialog) {
    this.marketoDialogRef = this.modalService.show(dialog, { class: 'modal-md' });
  }

  saveMarketo() {
    this.marketoDialogRef.hide();
    let update: any = {
      'integration.marketo': {
        endpoint: this.marketoConfig.endpoint,
        identity: this.marketoConfig.endpoint.replace(/\/rest/, '/identity'),
        client_id: this.marketoConfig.client_id,
        client_secret: this.marketoConfig.client_secret,
        created_at: new Date()
      }
    };

    this.accountService.updateAccount(update).subscribe(
      (result: any) => {
        this.globalMessageService.message('Marketo configuration saved');
        this.driftService.track('added-integration', { type: 'Marketo' });
        this.initView();
        this.testMarketo();
      },
      err => {
        this.globalMessageService.error();
        this.errorService.log(err, 'settings-integration.component', 'marketoSettings');
      }
    );
  }

  syncMarketo() {
    this.marketoConfig.resync = true;
    this.globalMessageService.message('We will resync your Marketo Lists. This may take a few minutes');
    this.marketoService.getLists('false').toPromise().catch(e => { /* shhh */ });
  }

  syncPardot() {
    this.globalMessageService.message('We will resync your Pardot Lists. This may take a few minutes');
    this.pardotConfig.resync = true;
    this.pardotService.getLists('false').toPromise().catch(e => { /* shhh */ });
  }

  syncEloqua() {
    this.globalMessageService.message('We will resync your Eloqua Lists. This may take a few minutes');
    this.eloquaConfig.resync = true;
    this.eloquaService.getLists('false').toPromise().catch(e => { /* shhh */ });
  }

  syncHubspot() {
    this.globalMessageService.message('We will resync your HubSpot Lists. This may take a few minutes');
    this.hubspotConfig.resync = true;
    this.hubspotService.getLists('false').toPromise().catch(e => { /* shhh */ });
  }

  testMarketo() {
    this.marketoConfig.testing = true;
    this.marketoConfig.tested = true;
    this.marketoService.getFields().subscribe(
      (result: any) => {
        this.marketoConfig.testing = false;
        if (result && result.length > 0) {
          this.marketoConfig.verified = true;
        }
        else {
          this.marketoConfig.verified = false;
        }
      },
      err => {
        this.marketoConfig.verified = false;
        this.marketoConfig.testing = false;
      });
  }

  testDrift() {
    this.driftConfig.testing = true;
    this.driftConfig.tested = true;
    this.driftService.getFields().subscribe(
      (result: any) => {
        this.driftConfig.testing = false;
        if (result && result.length > 0) {
          this.driftConfig.verified = true;
        }
        else {
          this.driftConfig.verified = false;
        }
      },
      err => {
        this.driftConfig.verified = false;
        this.driftConfig.testing = false;
      });
  }



  hubspotSettings() {
    //https://app.hubspot.com/oauth/authorize?client_id=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx&scope=contacts%20automation&redirect_uri=http://www.hubspot.com

    this.configService.hubspotConfig().subscribe(
      (config: any) => {
        var hubspotAuth = `${config.authUrl}?client_id=${config.clientId}&redirect_uri=${config.redirectUrl}&scope=${config.scopes}`;
        window.location.href = hubspotAuth;
      },
      err => {
        this.globalMessageService.error();
        this.errorService.log(err, 'settings-integration.component', 'hubspotSettings');
      });
  }

  testHubspot() {
    this.hubspotConfig.testing = true;
    this.hubspotConfig.tested = true;
    this.hubspotService.getFields().subscribe(
      (result: any) => {
        this.hubspotConfig.testing = false;
        if (result && result.length > 0) {
          this.hubspotConfig.verified = true;
        }
        else {
          this.hubspotConfig.verified = false;
        }
      },
      err => {
        this.hubspotConfig.verified = false;
        this.hubspotConfig.testing = false;
      });
  }

  eloquaSettings() {
    this.configService.eloquaConfig().subscribe(
      (config: any) => {
        var eloquaAuth = config.authUrl + '?response_type=code&client_id=' + config.clientId + '&redirect_uri=' + config.redirectUrl + '&scope=full';
        window.location.href = eloquaAuth;
      },
      err => {
        this.globalMessageService.error();
        this.errorService.log(err, 'settings-integration.component', 'eloquaSettings.100');
      });
  }

  testEloqua() {
    this.eloquaConfig.testing = true;
    this.eloquaConfig.tested = true;

    this.eloquaService.getFields().subscribe(
      (result: any) => {
        this.eloquaConfig.testing = false;
        if (result && result.length > 0) {
          this.eloquaConfig.verified = true;
        }
        else {
          this.eloquaConfig.verified = false;
        }
      },
      err => {
        this.eloquaConfig.verified = false;
        this.eloquaConfig.testing = false;
      });
  }

  pardotSettings(dialog) {
    this.pardotDialogRef = this.modalService.show(dialog, { class: 'modal-md' });
  }

  savePardot() {
    this.pardotDialogRef.hide();
    let update: any = {
      'integration.pardot': {
        email_address: this.pardotConfig.email_address,
        password: this.pardotConfig.password,
        client_key: this.pardotConfig.client_key,
        client_secret: this.pardotConfig.client_secret,
        token: this.pardotConfig.token,
        version: this.pardotConfig.version,
        business_unitId:this.pardotConfig.business_unitId,
        created_at: new Date(),
        is_sf_auth:true
      }
    };

    this.accountService.updateAccount(update).subscribe(
      (result: any) => {
        this.globalMessageService.message('Pardot configuration saved');
        this.driftService.track('added-integration', { type: 'Pardot' });
        this.initView();
        this.testPardot();
      },
      err => {
        this.globalMessageService.error();
        this.errorService.log(err, 'settings-integration.component', 'pardotSettings');
      }
    );
  }

  testPardot() {
    this.pardotConfig.tested = true;
    this.pardotConfig.testing = true;

    this.pardotService.getFields().subscribe(
      (fields: any) => {
        this.pardotConfig.testing = false;
        if (fields.length > 0) {
          this.pardotConfig.verified = true;
        }
        else {
          this.pardotConfig.verified = false;
        }
      },
      err => {
        this.pardotConfig.testing = false;
        this.pardotConfig.verified = false;
      }
    )
  }

  actOnSettings() {
    this.configService.actOnConfig().subscribe(
      (config: any) => {
        var actOnAuth = `${config.authUrl}?scope=PRODUCTION&response_type=code&client_id=${config.clientId}&redirect_uri=${config.redirectUrl}`;
        window.location.href = actOnAuth;
      },
      err => {
        this.globalMessageService.error();
        this.errorService.log(err, 'settings-integration.component', 'actOnSettings.100');
      });
  }

  testActOn() {
    this.actOnConfig.testing = true;
    this.actOnConfig.tested = true;
    this.actonService.getLists().subscribe(
      (result: any) => {
        this.actOnConfig.testing = false;
        if (result && result.length > 0) {
          this.actOnConfig.verified = true;
        }
        else {
          this.actOnConfig.verified = false;
        }
      },
      err => {
        this.actOnConfig.verified = false;
        this.actOnConfig.testing = false;
      });
  }

  private handleOAuth(callback) {
    var id = this.route.snapshot.params['id'];
    var params = this.route.snapshot.queryParams;
    if (id == 'hubspot') {
      if (params['error']) {
        this.modalService.show(AlertDialogComponent, Object.assign({}, {
          initialState: {
            message: `There was a problem connecting with HubSpot. Please try again and make sure you click the "Authorize" button when prompted.`,
            confirmBtn: 'Close'
          }
        }));
      }
      else {
        this.hubspotService.grantAccess(params['code']).subscribe(
          (result: any) => {
            this.driftService.track('added-integration', { type: 'HubSpot' });
            this.router.navigate(['/settings/integration']);
          },
          err => {
            this.globalMessageService.error();
            this.errorService.log(err, 'settings-integration.component', 'handleOAuth.200');
          }
        );
      }
    }
    else if (id == 'eloqua') {
      if (params['error']) {
        this.modalService.show(AlertDialogComponent, Object.assign({}, {
          initialState: {
            message: `There was a problem connecting with Eloqua. Please try again and make sure you click the "Authorize" button when prompted.`,
            confirmBtn: 'Close'
          }
        }));
      }
      else {
        this.eloquaService.grantAccess(params['code']).subscribe(
          (result: any) => {
            this.driftService.track('added-integration', { type: 'Eloqua' });
            this.router.navigate(['/settings/integration']);
          },
          err => {
            this.globalMessageService.error();
            this.errorService.log(err, 'settings-integration.component', 'handleOAuth.200');
          }
        );
      }
    }
    else if (id == 'acton') {
      if (params['error']) {
        this.modalService.show(AlertDialogComponent, Object.assign({}, {
          initialState: {
            message: `There was a problem connecting with Act-On. Please try again and make sure you click the "Authorize" button when prompted.`,
            confirmBtn: 'Close'
          }
        }));
      }
      else {
        this.actonService.grantAccess(params['code']).subscribe(
          (result: any) => {
            this.driftService.track('added-integration', { type: 'Act-On' });
            this.router.navigate(['/settings/integration']);
          },
          err => {
            this.globalMessageService.error();
            this.errorService.log(err, 'settings-integration.component', 'handleOAuth.300');
          }
        );
      }
    }
    else if (id == 'drift') {
      if (params['code']) {
        this.driftService.grantAccess(params['code']).subscribe(
          (result: any) => {
            this.driftService.track('added-integration', { type: 'Drift' });
            this.router.navigate(['/settings/integration']);
          },
          err => {
            this.globalMessageService.error();
            this.errorService.log(err, 'settings-integration.component', 'handleOAuth.drift.300');
          }
        );
      }
      else {
        this.modalService.show(AlertDialogComponent, Object.assign({}, {
          initialState: {
            message: `There was a problem connecting with Drift. Please try again.`,
            confirmBtn: 'Close'
          }
        }));
      }
    }
    else {
      callback();
    }
  }

  private initView() {
    this.loadingPage = true;
    this.integrations = false;

    this.marketoConfig = {
      endpoint: '',
      client_id: '',
      client_secret: '',
      testing: false,
      tested: false,
      verified: false
    };

    this.hubspotConfig = {
      hub_id: '',
      access_token: '',
      refresh_token: '',
      testing: false,
      tested: false,
      verified: false
    };

    this.eloquaConfig = {
      testing: false,
      tested: false,
      verified: false
    };

    this.actOnConfig = {
      testing: false,
      tested: false,
      verified: false
    };

    this.driftConfig = {
      testing: false,
      tested: false,
      verified: false
    };

    Observable.forkJoin(
      this.accountService.getIntegrations(),
      this.accountService.getApiTokens()
    ).subscribe(
      (result: any) => {
        this.accountData = result[0];
        this.apiTokens = result[1] || []; // defaulting so we don't have to backfill all accounts
        this.apiTokens.forEach((token) => {
          token.visible = false;
        });
        if (this.accountData.marketo) {
          this.marketoConfig.endpoint = this.accountData.marketo.endpoint;
          this.marketoConfig.client_id = this.accountData.marketo.client_id;
          this.marketoConfig.client_secret = this.accountData.marketo.client_secret;
          this.integrations = true;
        }

        if (this.accountData.hubspot) {
          this.hubspotConfig.hub_id = this.accountData.hubspot.hub_id;
          this.integrations = true;
        }

        if (this.accountData.eloqua) {
          this.integrations = true;
        }

        if (this.accountData.pardot) {
          this.pardotConfig.email_address = this.accountData.pardot.email_address;
          this.pardotConfig.password = this.accountData.pardot.password;
          this.pardotConfig.client_key = this.accountData.pardot.client_key;
          this.pardotConfig.client_secret = this.accountData.pardot.client_secret;
          this.pardotConfig.business_unitId = this.accountData.pardot.business_unitId;
          this.pardotConfig.token = this.accountData.pardot.token;
          this.integrations = true;
        }

        if (this.accountData.acton) {
          this.integrations = true;
        }

        if (this.accountData.drift) {
          this.integrations = true;
        }

        this.loadingPage = false;
      },
      err => {
        this.globalMessageService.error();
        this.errorService.log(err, 'settings-integration.component', 'initView');
      });


  }
}



// WEBPACK FOOTER //
// ./client/app/settings/settings-integration/settings-integration.component.ts